module.exports = new __parcel__URL__("ITSM Runbook.272077bd.svg").toString();